import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRewind: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconRewind"><Path d="M11.0093 12.441V17.3268C11.0093 18.181 10.0076 18.642 9.35881 18.0864L3.1386 12.7594C2.67255 12.3602 2.67255 11.6394 3.1386 11.2403L9.35881 5.91329C10.0076 5.3577 11.0093 5.81868 11.0093 6.67283V11.5587M11.0093 12.441L17.6012 18.0864C18.25 18.642 19.2517 18.181 19.2517 17.3268V6.67283C19.2517 5.81868 18.25 5.3577 17.6012 5.9133L11.0093 11.5587M11.0093 12.441V11.5587" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconRewind;
